import { render, staticRenderFns } from "./UserSelectListItem.vue?vue&type=template&id=0b711b23&scoped=true&"
import script from "./UserSelectListItem.vue?vue&type=script&lang=js&"
export * from "./UserSelectListItem.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectListItem.vue?vue&type=style&index=0&id=0b711b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b711b23",
  null
  
)

export default component.exports